import React, { useContext } from "react";
import AutocompleteTextInput from "components/FormElements/AutocompleteTextInput";
import Label from "components/FormElements/Label";
import { AssignmentContext } from "context/Assignment";
import { transform as issueTransformer } from "schemas/Issue";
import { apiGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";

export default function IssueField(props) {
    const auth = useAuth();
    const { loading, performingStateChange, isUserEditable } =
        useContext(AssignmentContext);

    if (loading) {
        return (
            <div>
                <Label>Issue</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <AutocompleteTextInput
            label="Issue"
            name="issue_label"
            id="issue_label"
            disabled={loading || performingStateChange || !isUserEditable}
            setValue={(item, field, setFieldValue) => {
                setFieldValue("issue_label", item.label);
                setFieldValue("issue_id", item.value);
            }}
            onEmptyFocus={async () => {
                const items = await apiGet("/v4/issue", auth.publication, {
                    order: "created_at",
                    dir: "desc",
                    per_page: 5,
                    page: 1,
                });

                return issueTransformer(items).map((item) => {
                    return {
                        label: item.decorated_label,
                        value: item.id,
                    };
                });
            }}
            onRequestSearch={async (term) => {
                const items = await apiGet("/v4/search", auth.publication, {
                    keyword: term,
                    per_page: 5,
                    type: "issue",
                });

                return issueTransformer(items).map((item) => {
                    return {
                        label: item.decorated_label,
                        value: item.id,
                    };
                });
            }}
        />
    );
}
